import React, { Fragment, useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faArrowDownWideShort,
    faArrowUp,
    faArrowUpShortWide, faArrowUpWideShort,
    faFilter, faRotateRight,
    faXmark
} from "@fortawesome/free-solid-svg-icons";
import { DropdownList } from "react-widgets";
import cx from "classnames";
import CratioTooltip from "../../Common/CratioTooltip";
import {faCirclePlus} from "@fortawesome/free-solid-svg-icons/faCirclePlus";

class FormHeader extends React.Component {
    sortField = {};
    defaultSort = "";
    constructor(props) {
        super(props);
        let lastSelectedTemplate = props.selectedTemplate[1];
        let lastSelectedTemplateId = props.selectedTemplate[0];
        let isRecordSelection = props.recordsSelected > 0;
        this.templateHolderRef = React.createRef(null);

        this.state = {
            showTemplatePopup: false,
            allTemplates: props.templates.length == 0 ? [] : props.templates,
            filteredTemplates: props.templates.length == 0 ? [] : props.templates,
            selectedTemplate: lastSelectedTemplate,
            selectedTemplateId: lastSelectedTemplateId,
            isRecordSelection: isRecordSelection,
        }
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside(event) {
        if (this.state.showTemplatePopup && this.templateHolderRef.current && !this.templateHolderRef.current.contains(event.target)) {
            this.setState({
                showTemplatePopup: false
            })
        }
    }

    showTemplateList = async (e) => {
        e.preventDefault();
        let currentPopup = this.state.showTemplatePopup;
        if (currentPopup) {
            currentPopup = false;
        } else {
            currentPopup = true;
        }
        this.setState({
            showTemplatePopup: currentPopup
        })
    }

    onTemplateChange = async (e, template) => {
        let currentPopup = this.state.showTemplatePopup;
        if (currentPopup) {
            currentPopup = false;
        } else {
            currentPopup = true;
        }
        let templateName = template[1];
        let templateId = template[0];
        this.setState({
            showTemplatePopup: currentPopup,
            selectedTemplate: templateName,
            selectedTemplateId: templateId
        });
        await this.props.loadData(template);
    }

    onTemplateSearch = async (e) => {
        let searchvalue = e.target.value;
        let allTemplates = this.state.allTemplates;
        let filterTemplates = [];
        let systemTemps = [];
        let publicTemps = [];
        let privateTemps = [];
        allTemplates.map((templates, tempindex) => {
            templates.map((template, index) => {
                let templateName = template[1];
                if (templateName.toLowerCase().includes(searchvalue.toLowerCase())) {
                    if (tempindex == '0') {
                        systemTemps.push(template);
                    } else if (tempindex == '1') {
                        publicTemps.push(template);
                    } else {
                        privateTemps.push(template);
                    }
                }
            })
        })
        filterTemplates.push(systemTemps);
        filterTemplates.push(publicTemps);
        filterTemplates.push(privateTemps);
        this.setState({
            filteredTemplates: filterTemplates
        })
    }
    onSelectAllClicked = async (e) => {
        let isChecked = e.target.checked;
        this.props.onSelectAll(isChecked);
    }
    onSortListChange = async (item) => {
        this.sortField = item;
        this.props.onSortList(item, this.defaultSort);
    }
    onSortFunctionChange = async (e) => {
        let currentSort = this.defaultSort;
        let newSortdir = "asc";
        if (currentSort == "asc") {
            newSortdir = "desc";
        }
        let sortField = this.sortField;
        this.defaultSort = newSortdir
        await this.onSortListChange(sortField);
    }
    render() {
        if (this.props.sortFields.length <= 0) {
            return <></>
        }
        let isShowTemplatePopup = this.state.showTemplatePopup;
        let templates = this.state.filteredTemplates;
        let selectedTemplate = this.state.selectedTemplate;
        let selectedTemplateId = this.state.selectedTemplateId;
        let isRecordSelection = this.props.recordsSelected > 0;
        let sortFields = this.props.sortFields;
        let fieldsSorting = this.props.fieldsSorting;
        let sortFieldList = [];
        let defaultValue = "";
        this.sortField = {};
        for (let i = 0; i < sortFields.length && i < 4; i++) {
            let fieldLabel = sortFields[i][3];
            let fieldName = sortFields[i][2];
            let fieldSortingValue = Number(fieldsSorting[i]);
            if (fieldSortingValue > 0) {
                defaultValue = fieldLabel;
                if (this.defaultSort == "") {
                    this.defaultSort = fieldSortingValue == 1 ? 'asc' : 'desc';
                }
                this.sortField = { id: fieldName, value: fieldLabel };
            }
            sortFieldList.push({ id: fieldName, value: fieldLabel });
        }
        if (defaultValue == "") {
            let fieldLabel = sortFields[0][3];
            let fieldName = sortFields[0][2];
            defaultValue = fieldLabel;
            this.sortField = { id: fieldName, value: fieldLabel };
            if (this.defaultSort == "") {
                this.defaultSort = 'desc';
            }
        }
        return (
            <Fragment>
                <div className={cx(
                    "listview-header header-btn ",
                    { 'head-transform-active': isRecordSelection },
                )} > {/* head-transform-active */}
                    <div className="listview-btn-left">
                        <div className={cx(
                            "listview-defaultgroup semi-bold  ",
                            { 'head-transform-hideview': isRecordSelection },
                        )} id="defaultactionleft">{/* head-transform-hideview */}
                            <div className="flex-center-v pR header-default">
                                <button onClick={(e) => { this.props.openFilterPanel(e) }} className="filter-btn icon-round-btn filter-active">
                                    <span className="top-nav-btn notification-icon">
                                        <FontAwesomeIcon className="ms-2 opacity-8 bigin-sprite ignite-icon-notification" icon={faFilter} />
                                    </span>
                                </button>
                                <div className="form-field ml-2">
                                    <div className="form-field-wrapper">
                                        <div className="custom-view-options pull-left">
                                            <sm-custom-popover className="sm-custom-popover">
                                                <div className="custom-view-popover pR arrow-left-corner t-f-tl">
                                                    <a onClick={(e) => { this.showTemplateList(e) }}
                                                        className={cx(
                                                            `btn btn-default popover-action ml-1`,
                                                            { 'popover-opened': isShowTemplatePopup }
                                                        )}>
                                                        <CratioTooltip title={selectedTemplate} content={<span className="text-ellipsis selected-text"><span className={`le-active-font`}>{selectedTemplate}</span>  <i className="caret"></i></span>} />
                                                    </a>
                                                    <popper-content>
                                                        <div className={cx(
                                                            "ngxp__container ngxp__animation",
                                                            { 'popup-show': isShowTemplatePopup },
                                                        )}
                                                            aria-hidden="true" role="popper"
                                                        >
                                                            <div className="ngxp__inner">
                                                                <div className="custom-view-popover-body">
                                                                    <div id="popover1-body"
                                                                        className="popover-view-content">
                                                                        <div ref={this.templateHolderRef} className="popover1-menu">
                                                                            <div className="popper-search-block">
                                                                                <form noValidate="" name="frmSearchView"
                                                                                    id="frmSearchView"
                                                                                    className="ng-pristine ng-valid ng-touched">
                                                                                    <input type="text" onKeyUp={(e) => { this.onTemplateSearch(e) }} name="searchView"
                                                                                        autoComplete="off"
                                                                                        className="form-control ng-pristine ng-valid ng-touched"
                                                                                        placeholder="Search Views" />
                                                                                </form>
                                                                            </div>
                                                                            <div>
                                                                                <div className="popover-list">
                                                                                    <ul>
                                                                                        {
                                                                                            templates.map((data, tindex) => {
                                                                                                let groupName = "System";
                                                                                                if (tindex == 1) {
                                                                                                    groupName = "Public";
                                                                                                } else if (tindex == 2) {
                                                                                                    groupName = "Private";
                                                                                                }
                                                                                                if (data.length == 0) {
                                                                                                    return <></>
                                                                                                }
                                                                                                return (
                                                                                                    <>
                                                                                                        <ol className="uppercase">{groupName}</ol>
                                                                                                        {
                                                                                                            data.map((template, index) => {
                                                                                                                let templateid = template[0];
                                                                                                                let templatename = template[1];
                                                                                                                return (
                                                                                                                    <li onClick={(e) => { this.onTemplateChange(e, template) }} className={cx(
                                                                                                                        "show-on-hover template-list-items",
                                                                                                                        { 'selected': templateid == selectedTemplateId },
                                                                                                                    )} >
                                                                                                                        <a><i className="icon-check"
                                                                                                                            hidden=""></i><span><i
                                                                                                                                className="icon-lock m-r-sm"></i></span> {templatename} </a>
                                                                                                                        <span
                                                                                                                            data-toggle="dropdown"
                                                                                                                            className="icon-option star-on-hover"
                                                                                                                            data-original-title=""
                                                                                                                            title=""><i
                                                                                                                                className="icon-star"></i></span>
                                                                                                                        <div>
                                                                                                                            <a data-toggle="dropdown"
                                                                                                                                className="icon-option pull-right hide"
                                                                                                                                data-original-title=""
                                                                                                                                title=""><i
                                                                                                                                    className="icon-trash"></i></a>
                                                                                                                        </div>
                                                                                                                    </li>
                                                                                                                )
                                                                                                            })
                                                                                                        }
                                                                                                    </>
                                                                                                )
                                                                                            })
                                                                                        }

                                                                                    </ul>

                                                                                </div>
                                                                            </div>
                                                                            <div
                                                                                data-zcqa="createViewOption"
                                                                                title=""
                                                                                className="lv-header-view-pick-footer cP dd-footer-btn link"
                                                                                click="ux-single-picklist => onFooterActionClicked()">
                                                                                <i className="ignite-icon-plus-blue bigin-sprite mR7"></i> Create View
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="ngxp__arrow"></div>
                                                        </div>
                                                    </popper-content>
                                                </div>
                                            </sm-custom-popover>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className={cx(
                            "listview-checkedgroup  ",
                            { 'head-more-info-hide': !isRecordSelection },
                            { 'head-transform-showview': isRecordSelection },
                        )} id="bulkactioncontent">{/* head-transform-showview */}
                            <ux-button-group class="ux-btn-group">
                                <div className={'d-flex'}>
                                    <div className="button_primary">
                                        <le-button className="btn-group-item">
                                            <button type="button" onClick={(e) => { this.props.massUpdateFields(e) }} className="le-button lePrimaryBtn" value=""
                                                tabIndex="-1" id="" name="">
                                                <le-yield yield-name="text"><span> Update Field </span></le-yield>
                                            </button>
                                            <button type="button" onClick={(e) => { this.props.deleteLeads(e) }} className="le-button lePrimaryBtn ml-1" value=""
                                                tabIndex="-1" id="" name="">
                                                <le-yield yield-name="text"><span> Delete </span></le-yield>
                                            </button>
                                        </le-button>
                                    </div>
                                    <div className={'record-select-all ml25 hide'}>
                                        <div className={'select-wrapper'}>
                                            <input onClick={(e => { this.onSelectAllClicked(e.target.checked) })} title={"Select All"} type={'checkbox'} />
                                            <label className={'ml-1'}>
                                                Select All
                                            </label>
                                            <a className={'deselect-all-wrapper ml-2 hide'}><FontAwesomeIcon icon={faXmark} /></a>
                                        </div>
                                    </div>
                                </div>
                            </ux-button-group>
                        </div>
                    </div>
                    <div className="listview-btn-right ar">
                        <div className="listview-options-div" id="defaultactionright">
                            <div className="mR10 pR dInlineFlex">
                                <div className="form-label"> Sort By</div>
                                <DropdownList data={sortFieldList} dataKey='id'
                                    textField='value' defaultValue={defaultValue} onChange={this.onSortListChange} />
                            </div>
                            <div className={"mR10 pR dInlineFlex"}>
                                <div className={'form-field '}>
                                    <div className={'form-field-wrapper'}>
                                        <a onClick={(e => { this.onSortFunctionChange(e) })} className={'field-input sort-btn '}>
                                            <span>
                                                <FontAwesomeIcon icon={this.defaultSort == "asc" ? faArrowUpWideShort : faArrowDownWideShort} />
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <span className="double-primary-btn mR7 lv-header-module-create-import-btn">
                                <le-button className="btn-add header-btn">
                                    <button type="button" onClick={(event => { this.props.openAddLead(event) })} className="le-button lePrimaryBtn">
                                        <span className="ux-icon-button">
                                            <FontAwesomeIcon icon={faCirclePlus}/>
                                            <span className="double-btn-text ml-1" data-ellipsis="true">Lead</span>
                                        </span>
                                    </button>
                                </le-button>
                            </span>
                            <div className={"mR10 pR dInlineFlex ml-1"}>
                                <div className={'form-field '}>
                                    <div className={'form-field-wrapper'}>
                                        <a onClick={(e => { this.props.refreshCurrentPage(e) })} className={'field-input sort-btn '}>
                                            <span>
                                                <FontAwesomeIcon icon={faRotateRight} />
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default FormHeader;
